// Import Assets
import DefaultProfilePicture from './../../assets/Illustrations/Profile/Default_Profile_Picture.png';
import CrowdIllustration from './../../assets/Illustrations/Profile/Crowd_Illustration.jpg';

export const defaultProfilePicture = DefaultProfilePicture;
export const crowdIllustration = CrowdIllustration;
